import React, { useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { GET_INSTITUTION } from '../constant';
import { getInstitutionList } from '../action';

const selectList = ({ api }) => {
  return _.get(api, `${GET_INSTITUTION}.list`) || [];
};

const formatOptions = data => {
  return data.map(item => {
    return {
      label: _.get(item, 'attributes.name'),
      value: _.get(item, 'attributes.code'),
      fullInfo: item,
    };
  });
};

const Institution = ({ onChange, name, value, readOnly }) => {
  const dispatch = useDispatch();
  const list = useSelector(selectList);
  const options = formatOptions(list);

  const findValue =
    options.find(item => _.get(item, 'fullInfo.attributes.code') === value) ||
    '';

  useEffect(() => {
    if (value) dispatch(getInstitutionList({ code: value }));
  }, [value]);

  const handleChange = data => {
    onChange({
      target: {
        name,
        value: data ? data.value : '',
        label: data ? data.label : '',
      },
    });
  };

  const loadOptions = (inputValue, callback) => {
    dispatch(
      getInstitutionList({ q: inputValue }, response => {
        callback(formatOptions(_.get(response, 'data')));
      })
    );
  };

  const loadOptionsDebounce = _.debounce(loadOptions, 500);

  return readOnly === true ? (
    <span className="full-input text-uppercase">
      {_.get(findValue, 'label')}
    </span>
  ) : (
    <AsyncSelect
      isClearable
      placeholder="- Type to Search -"
      value={findValue}
      defaultOptions={formatOptions(list)}
      loadOptions={loadOptionsDebounce}
      onChange={handleChange}
      components={{
        IndicatorSeparator: () => null,
      }}
    />
  );
};

Institution.defaultProps = {
  name: undefined,
  readOnly: undefined,
};

Institution.propTypes = {
  readOnly: PropTypes.bool,
  onChange: PropTypes.instanceOf(Function).isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string,
};

export default Institution;
